import React from "react"

import styled from "styled-components"

const Container = ({ children }) => {
  return <ContainerWrapper >{children}</ContainerWrapper>
}

export { Container }

const ContainerWrapper = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 16px;
  height: 100%;
  position: relative;

@media (min-width: ${({ theme }) => theme.media.tablet_min}) {
  padding: 0 32px;
},
`
